import * as React from "react"
import Svg, { SvgProps, G, Path, Defs, ClipPath } from "react-native-svg"
const UmbrellaIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <G
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#a)"
    >
      <Path d="M17.553 17.07a7.5 7.5 0 0 0-10.606 0M18 4.123A6 6 0 0 0 9.804 6.32l10.392 6A6 6 0 0 0 18 4.123Z" />
      <Path d="M16.732 10.32C18.39 7.45 18.957 4.674 18 4.122c-.957-.552-3.075 1.326-4.732 4.196M15 9.32l-3 5.195M3 19.57a2.4 2.4 0 0 1 1-.25 2.4 2.4 0 0 1 2 1 2.4 2.4 0 0 0 2 1 2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 2-1 2.4 2.4 0 0 1 2 1 2.4 2.4 0 0 0 2 1 2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 2-1 2.4 2.4 0 0 1 1 .25" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 .32h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default UmbrellaIcon
